<ng-container>
  <div class="information-box">
    <p>Favela: {{this.information.favela}}</p>
    <p>Morfologia: {{this.information.morfologia}}</p>
    <p>Bairro: {{this.information.bairro}}</p>
    <p>Código do bairro: {{this.information.cod_bairro}}</p>
    <p>Região de Plenejamento: {{this.information.rp}}</p>
    <p>Código da RP: {{this.information.rp_cod}}</p>
    <p>Região Administrativa: {{this.information.ra}}</p>
    <p>Código da RA: {{this.information.ra_cod}}</p>
  </div>
    <p>Categoria de entrada: {{this.information.cat_entrada}}</p>
    <p>Tipologia de entrada: {{this.information.tipo_entrada}}</p>
    <p>Grau de entrada: {{this.information.grau_entrada}}</p>
</ng-container>